import React from 'react';
import HeroSection from '../components/home/HeroSection';
import ValueProposition from '../components/home/ValueProposition';
import StatsHighlight from '../components/home/StatsHighlight';
import Services from '../components/home/Services';
import WhyChooseUs from '../components/home/WhyChooseUs';
import Testimonials from '../components/home/Testimonials';
import CallToAction from '../components/shared/CallToAction';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ValueProposition />
      <StatsHighlight />
      <Services />
      <WhyChooseUs />
      <Testimonials />
      <CallToAction />
    </>
  );
};

export default HomePage; 